// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const EMOJI_SPRITE_SHEET = import.meta.env.VITE_EMOJI_SPRITE_SHEET
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const WAPP_EMOJI_SPRITE_SHEET = import.meta.env
  .VITE_WAPP_EMOJI_SPRITE_SHEET
